/*! bxs-vue-ui v4.0.1 */
import { m as map, i as indexOf } from './es.array.join.js';
import { c as concat } from './concat.js';

var _context;

var ua = navigator.userAgent;
var env = {
  isAndroid: /Android/i.test(ua),
  isIos: /(iPhone|iPad|iPod)/i.test(ua),
  supportTouch: function isSupportTouch() {
    return !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
  }()
};

var DEVICE_VIEWPORT_SPECS = map(_context = [[375, 812, 3], // iPhone X, 11 Pro,
[414, 896, 2], // iPhone XR, 11,
[414, 896, 3], // iPhone XS Max, 11 Pro Max,
[390, 844, 3], // iPhone 12, 12 Pro,
[428, 926, 3] // iPhone 12 Pro Max,
]).call(_context, function (it) {
  return it.join(',');
});

var isAfterIphoneX = function isAfterIphoneX() {
  var _context2;

  if (!/iphone/gi.test(ua)) {
    return false;
  }

  var _window$screen = window.screen,
      width = _window$screen.width,
      height = _window$screen.height;

  var demensions = concat(_context2 = width > height ? [height, width] : [width, height]).call(_context2, window.devicePixelRatio);

  return indexOf(DEVICE_VIEWPORT_SPECS).call(DEVICE_VIEWPORT_SPECS, demensions.join(',')) !== -1;
};
function addXSupport() {
  var $viewport = document.querySelector('meta[name=viewport]');

  if (!$viewport || !isAfterIphoneX()) {
    return false;
  }

  var content = $viewport.getAttribute('content');

  if (indexOf(content).call(content, 'viewport-fit') !== -1) {
    return false;
  }

  content += ',viewport-fit=cover';
  $viewport.setAttribute('content', content);
  return true;
}

export { addXSupport as a, env as e, isAfterIphoneX as i };
